import { render, staticRenderFns } from "./SpeakerSectionIcon.vue?vue&type=template&id=39fbc944"
import script from "./SpeakerSectionIcon.vue?vue&type=script&lang=js"
export * from "./SpeakerSectionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports